/**
 * @file charts/constants.js
 * @author zhuping04
 */

export const ALL_COLOR = [
    '#1890FF',
    '#FACC14',
    '#2FC25B',
    '#8543E0',
    '#F04864',
    '#13C2C2',
    '#fa8c16',
    '#a0d911'
];